var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var DrawerImage = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: none;\n  background-image: url(", ");\n  background-size: cover;\n  width: 100%;\n  height: 180px;\n"], ["\n  flex: none;\n  background-image: url(", ");\n  background-size: cover;\n  width: 100%;\n  height: 180px;\n"])), function (props) { return props.imgSrc; });
var templateObject_1;
